/* Elite Refined: tidy personalised keychain lines in the Upcart drawer and the cart page.
   Hides technical line-item properties and shows the customer's own front preview as the thumbnail. */
(function () {
  'use strict';
  var LEGACY = /^(Custom Engraving Photo|Engraving Crop( \(send to supplier\))?|Preview Front|Preview Back|Personalization)$/;
  function hiddenKey(key) { key = key.trim(); return key.charAt(0) === '_' || LEGACY.test(key); }
  function previewUrl(props) {
    for (var i = 0; i < props.length; i++) {
      var m = props[i].match(/^\s*_?Preview Front:\s*(https?:\/\/\S+)/);
      if (m) return m[1];
    }
    return null;
  }
  function setThumb(img, url) {
    /* Upcart re-renders and resets src, so compare against the live src rather than a marker. */
    if (!img || !url || img.src === url) return;
    img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = url; img.style.objectFit = 'cover';
  }
  /* Pretty summary card for personalised keychain lines (brand: navy #1F2A44, gold #C9A55C, ivory #F7F2EA). */
  var CARD_CSS = '.er-kc-card{box-sizing:border-box;max-width:340px;margin:6px 0 4px;padding:8px 10px;border-radius:10px;background:#F7F2EA;border:1px solid #ECE3D3;display:flex;flex-direction:column;gap:6px;font-size:12px;line-height:1.35;color:#1F2A44}'
    + '.er-kc-line{display:flex;align-items:center;gap:6px;flex-wrap:wrap;font-weight:600}.er-kc-line>*{white-space:nowrap}'
    + '.er-kc-dot{width:12px;height:12px;border-radius:50%;flex:0 0 12px;box-shadow:inset 0 0 0 1px rgba(0,0,0,.12)}'
    + '.er-kc-dot--silver{background:linear-gradient(135deg,#f4f4f4,#9a9da0 55%,#e9e9e9)}.er-kc-dot--gold{background:linear-gradient(135deg,#fff1c2,#c9a55c 55%,#f6dc9a)}.er-kc-dot--rose{background:linear-gradient(135deg,#ffe2d6,#c98a76 55%,#f7c9b8)}'
    + '.er-kc-muted{color:#7a7266;font-weight:500}'
    + '.er-kc-chip{display:inline-flex;align-items:center;gap:6px;align-self:flex-start;max-width:100%;padding:3px 9px 3px 7px;border-radius:999px;background:#fff;border:1px solid #E5D9C2}'
    + '.er-kc-chip svg{width:12px;height:12px;flex:0 0 12px;color:#C9A55C}'
    + '.er-kc-chip b{font-weight:700}'
    + '.er-kc-quote{padding-left:9px;border-left:2px solid #C9A55C;font-family:Georgia,"Times New Roman",serif;font-style:italic;font-size:13px;color:#33384a;word-break:break-word}'
    + '.er-kc-label{display:block;font-family:inherit;font-style:normal;font-size:9.5px;letter-spacing:.08em;text-transform:uppercase;color:#9a8f7e;margin-bottom:1px}'
    + '.er-kc-chip .er-kc-label{display:inline;margin:0;white-space:nowrap}'
    + '.er-kc-chip{flex-wrap:wrap}.er-kc-chip b{white-space:normal;word-break:break-word}'
    + '@media(max-width:749px){.cart-item__details>.er-kc-card{width:min(220px,calc(100vw - 150px))}}'
    + '.er-kc-thumb{border-radius:12px!important;background:#F7F2EA!important;box-shadow:0 0 0 1px #ECE3D3!important;object-fit:cover!important}';
  var TAG_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';
  function addStyle(root) {
    if (root.querySelector && root.querySelector('style[data-er-kc]')) return;
    var st = document.createElement('style'); st.setAttribute('data-er-kc', ''); st.textContent = CARD_CSS;
    (root.head || root).appendChild(st);
  }
  function finishOf(text) { return /rose/i.test(text) ? 'rose' : /gold/i.test(text) ? 'gold' : 'silver'; }
  function buildCard(info) {
    var card = document.createElement('div'); card.className = 'er-kc-card'; card.dataset.sig = info.sig;
    var line = document.createElement('div'); line.className = 'er-kc-line';
    var dot = document.createElement('span'); dot.className = 'er-kc-dot er-kc-dot--' + finishOf(info.finish);
    var fin = document.createElement('span'); fin.textContent = info.finish;
    var sep = document.createElement('span'); sep.className = 'er-kc-muted'; sep.textContent = '· Photo engraved';
    line.append(dot, fin, sep); card.appendChild(line);
    if (info.name) {
      var chip = document.createElement('div'); chip.className = 'er-kc-chip'; chip.innerHTML = TAG_ICON;
      var lab = document.createElement('span'); lab.className = 'er-kc-label'; lab.textContent = 'Name tag';
      var nm = document.createElement('b'); nm.textContent = info.name; chip.append(lab, nm); card.appendChild(chip);
    }
    if (info.back) {
      var q = document.createElement('div'); q.className = 'er-kc-quote';
      var ql = document.createElement('span'); ql.className = 'er-kc-label'; ql.textContent = 'Back message';
      q.appendChild(ql); q.appendChild(document.createTextNode('“' + info.back + '”')); card.appendChild(q);
    }
    return card;
  }
  function placeCard(anchorEl, info) {
    var existing = anchorEl.parentNode && anchorEl.parentNode.querySelector(':scope > .er-kc-card');
    if (existing && existing.dataset.sig === info.sig) return;
    if (existing) existing.remove();
    anchorEl.insertAdjacentElement('afterend', buildCard(info));
  }
  /* Upcart renders each property as "Key: value" inside its shadow root. */
  function tidyUpcart(root) {
    root.querySelectorAll('.upcart-public-cart-item').forEach(function (item) {
      var spans = Array.from(item.querySelectorAll('.upcart-public-cart-items__key-value-pair'));
      var texts = spans.map(function (s) { return s.textContent; });
      spans.forEach(function (s) {
        var key = s.textContent.split(':')[0];
        if (hiddenKey(key)) { var row = s.closest('.upcart-public-product-properties__item') || s; if (row.style.display !== 'none') row.style.display = 'none'; }
      });
      var url = previewUrl(texts), img = item.querySelector('img');
      setThumb(img, url);
      var props = {};
      texts.forEach(function (t) { var i = t.indexOf(':'); if (i > 0) props[t.slice(0, i).trim()] = t.slice(i + 1).trim(); });
      var variant = item.querySelector('.upcart-public-component-product-tile__variant');
      if (!url || !variant) return;
      /* Personalised keychain: replace the raw variant/property lines with the summary card. */
      var finish = (variant.textContent.match(/Color:\s*([^,]+)/i) || [])[1] || 'Silver';
      var info = { finish: finish.trim(), name: props['Name Tag'] || '', back: props['Back Engraving'] || '' };
      info.sig = [info.finish, info.name, info.back].join('|');
      if (img && !img.classList.contains('er-kc-thumb')) img.classList.add('er-kc-thumb');
      variant.style.display = 'none';
      var propsBox = item.querySelector('.upcart-public-component-product-tile__properties'); if (propsBox) propsBox.style.display = 'none';
      placeCard(variant, info);
    });
  }
  /* Theme cart page / theme drawer: <div class="product-option"><dt>Key:</dt><dd>value</dd></div>. */
  function tidyTheme() {
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var preview = null;
      row.querySelectorAll('.product-option').forEach(function (opt) {
        var dt = opt.querySelector('dt'), dd = opt.querySelector('dd'); if (!dt) return;
        var key = dt.textContent.replace(/:\s*$/, '');
        if (/^_?Preview Front$/.test(key.trim()) && dd) { var a = dd.querySelector('a'); preview = a ? a.href : dd.textContent.trim(); }
        if (hiddenKey(key) && opt.querySelector('a')) opt.style.display = 'none';
      });
      if (!preview) preview = cartPreview(row);
      var thumb = row.querySelector('.cart-item__media img, .cart-item__image');
      setThumb(thumb, preview);
      var opts = Array.from(row.querySelectorAll('.product-option'));
      if (!preview || !opts.length) return;
      var get = function (k) { var o = opts.find(function (x) { var dt = x.querySelector('dt'); return dt && dt.textContent.replace(/:\s*$/, '').trim() === k; }); return o ? o.querySelector('dd').textContent.trim().replace(/,$/, '') : ''; };
      var info = { finish: get('Color') || 'Silver', name: get('Name Tag'), back: get('Back Engraving') };
      info.sig = [info.finish, info.name, info.back].join('|');
      if (thumb && !thumb.classList.contains('er-kc-thumb')) thumb.classList.add('er-kc-thumb');
      opts.forEach(function (o) { o.style.display = 'none'; });
      var list = opts[0].closest('dl') || opts[opts.length - 1];
      placeCard(list, info);
    });
  }
  /* The theme omits underscore properties from its markup, so read them from /cart.js (rows are id="CartItem-<index>"). */
  var cartItems = null, cartLoading = false, cartFetches = 0;
  function cartPreview(row) {
    var m = (row.id || '').match(/(\d+)$/);
    if (!m) return null;
    if (!cartItems) {
      if (!cartLoading && cartFetches < 6) { cartLoading = true; cartFetches++; fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { cartItems = c.items || []; tidyTheme(); }).catch(function () {}); }
      return null;
    }
    var item = cartItems[Number(m[1]) - 1];
    /* After a quantity change the rows re-render; drop a stale snapshot instead of mislabelling a row. */
    if (!item || row.textContent.indexOf(item.product_title) === -1 || (item.properties && item.properties['Name Tag'] && row.textContent.indexOf(item.properties['Name Tag']) === -1)) { cartItems = null; cartLoading = false; return null; }
    return item.properties && (item.properties['_Preview Front'] || item.properties['Preview Front']) || null;
  }
  document.addEventListener('cart:updated', function () { cartItems = null; cartLoading = false; });
  var watched = new WeakSet();
  function watch(root, fn) {
    if (watched.has(root)) return; watched.add(root);
    var pending = false;
    new MutationObserver(function () { if (pending) return; pending = true; setTimeout(function () { pending = false; fn(); }, 30); }).observe(root, { childList: true, subtree: true });
    fn();
  }
  function hookUpcart() {
    var host = document.getElementById('upCart');
    if (host && host.shadowRoot) { addStyle(host.shadowRoot); watch(host.shadowRoot, function () { tidyUpcart(host.shadowRoot); }); }
  }
  function boot() {
    addStyle(document);
    watch(document.body, function () { tidyTheme(); hookUpcart(); });
    /* Upcart attaches its shadow root after load without touching the light DOM, so keep checking for it. */
    setInterval(hookUpcart, 800);
  }
  /* Buy More Save More: keep the right bundle code on the cart (2 keychains 15%, 3+ 20%).
     Codes are used because the store is at Shopify's automatic-discount limit. */
  var KC_HANDLE = 'personalized-photo-engraved-keychain-round-stainless-steel-gift';
  var KC_CODES = { 2: 'KEYCHAIN2SAVE15', 3: 'KEYCHAIN3SAVE20' };
  var syncing = null;
  function syncDiscount() {
    if (syncing) return syncing;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    syncing = fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var n = 0; (cart.items || []).forEach(function (i) { if (i.handle === KC_HANDLE) n += i.quantity; });
      var want = n >= 3 ? KC_CODES[3] : n === 2 ? KC_CODES[2] : '';
      var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
      var ours = codes.filter(function (c) { return c === KC_CODES[2] || c === KC_CODES[3]; });
      if ((want && ours.length === 1 && ours[0] === want) || (!want && !ours.length)) return;
      var others = codes.filter(function (c) { return c !== KC_CODES[2] && c !== KC_CODES[3]; });
      /* Never replace a code the shopper typed themselves. */
      if (want && others.length) return;
      var next = want ? [want] : others;
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ discount: next.join(',') }) });
    }).catch(function () {}).then(function () { syncing = null; });
    return syncing;
  }
  window.ERKeychainDiscount = { sync: syncDiscount };
  /* Re-check whenever the cart contents change (drawer, cart page, product page). */
  var origFetch = window.fetch;
  window.fetch = function (resource) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url) && !/discount/.test(String(arguments[1] && arguments[1].body || ''))) p.then(function () { setTimeout(syncDiscount, 250); }).catch(function () {});
    return p;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); syncDiscount(); }); else { boot(); syncDiscount(); }
})();

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
